import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import LabelValue from '../../LabelValue';
import { Provider } from '../../../data/models/provider.model';
import { useFormatDate } from '../../../hooks/useFormatDate';
import { useLegalEntityStatus } from '../../../hooks/useLegalEntityStatus';
import { useLegalEntityType } from '../../../hooks/useLegalEntityType';
import addressUtils, {
  ProviderAddressUse,
} from '../../../services/addressUtils';
import emailUtils, { ProviderEmailUse } from '../../../services/emailUtils';
import phoneUtils, { ProviderPhoneUse } from '../../../services/phoneUtils';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';

interface LegalInfoProps {
  provider: Provider | null;
  titleStyle: string;
}

export default function LegalInfo(props: LegalInfoProps) {
  const { t } = useTranslation('common');

  const { provider, titleStyle } = props;

  const email = emailUtils.getProviderEmail(
    provider?.emailAddresses,
    ProviderEmailUse.Owner,
  );

  const phone = phoneUtils.getProviderPhone(
    provider?.phoneNumbers,
    ProviderPhoneUse.Owner,
  );

  const address = addressUtils.getProviderAddress(
    provider?.addresses,
    ProviderAddressUse.Physical,
  );

  return (
    <>
      <Typography className={titleStyle}>{t('provider.legal')}</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.ein')}
            value={provider?.employerIdentificationNumber}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.ownerFirstName')}
            value={provider?.ownerFirstName}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.ownerLastName')}
            value={provider?.ownerLastName}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.ownerEmail')}
            value={email?.emailAddress}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.ownerPhone')}
            // value={usePhone(phone)}
            value={`${phone?.phoneNumber} ${
              phone?.phoneExtension
                ? `${t('common.extension')}. ${phone.phoneExtension}`
                : ''
            }`}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.permitExpires')}
            value={useFormatDate(provider?.businessPermitExpiresOn)}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.legalState')}
            value={provider?.legalEntityStateCode}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.legalType')}
            value={useLegalEntityType(provider?.legalEntityTypeID)}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.legalStatus')}
            value={useLegalEntityStatus(provider?.legalEntityStatusID)}
          />
        </Grid>
        {/* TODO: put this back in */}
        {/* <AddressDisplay
          address={address?.Address}
          addressLabel={t('provider.physicalAddress') || ''}
        /> */}
      </Grid>
    </>
  );
}
